const storeName = 'myAccount';

export default {
    SET_DATA_ATTR: `${storeName}.SET_DATA_ATTR`,
    SET_CARD_NUMBER: `${storeName}.SET_CARD_NUMBER`,
    GET_SAVED_CARD: `${storeName}.GET_SAVED_CARD`,
    SET_SAVED_CARD: `${storeName}.SET_SAVED_CARD`,
    VALIDATE_CARD: `${storeName}.VALIDATE_CARD`,
    SET_DATA_FIELD_VALUE: `${storeName}.SET_DATA_FIELD_VALUE`,
    SET_SELECTED_CARD: `${storeName}.SET_SELECTED_CARD`,
    EDIT_SAVED_CARD: `${storeName}.EDIT_SAVED_CARD`,
    SUBMIT: `${storeName}.SUBMIT`,
    SET_SAVED_CARD_LOADED: `${storeName}.SET_SAVED_CARD_LOADED`,
    SET_LOYALTY_POINT_BALANCE: `${storeName}.SET_LOYALTY_POINT_BALANCE`,
    SET_LOYALTY_EMPLOYEE_POINT_BALANCE: `${storeName}.SET_LOYALTY_EMPLOYEE_POINT_BALANCE`,
    GET_LOYALTY_POINT_BALANCE: `${storeName}.GET_LOYALTY_POINT_BALANCE`,
    SET_SWIPE_TO_VALIDATION: `${storeName}.SET_SWIPE_TO_VALIDATION`,
    SET_SWIPE_TO_BUY_ORDER_CONFIRMATION_CODE: `${storeName}.SET_SWIPE_TO_BUY_ORDER_CONFIRMATION_CODE`,
    FETCH_FORM_DATA: `${storeName}.FETCH_FORM_DATA`,
    SET_SWIPE_TO_BUY_ERROR: `${storeName}.SHOW_SWIPE_TO_BUY_ERROR`,
    SET_SWIPE_TO_BUY_ERROR_TYPE: `${storeName}.SWIPE_TO_BUY_ERROR_TYPE`,
};
